import 'intersection-observer';
import PropTypes from 'prop-types';
import { useState, useRef, useEffect } from 'react';
import { jsx } from 'react/jsx-runtime';

/* global IntersectionObserver */
const withDetectInViewport = Component => {
  const wrapped = props => {
    const {
      delay,
      reset,
      root,
      rootMargin,
      threshold
    } = props;
    const [showElement, setShowElement] = useState(false);
    const animateElement = useRef(null);
    const observeCallback = (entry, observer) => {
      const thresholdLocal = observer.thresholds[0];
      if (entry[0].intersectionRatio >= thresholdLocal) {
        if (delay) {
          setTimeout(() => {
            setShowElement(true);
          }, delay);
        } else {
          setShowElement(true);
        }
      } else if (reset) setShowElement(false);
    };
    const observe = element => {
      const observer = new IntersectionObserver(observeCallback, {
        root,
        rootMargin,
        threshold
      });
      observer.observe(element.current);
    };
    useEffect(() => {
      observe(animateElement);
    });
    return /*#__PURE__*/jsx("span", {
      className: "detect-wrapper",
      ref: animateElement,
      children: /*#__PURE__*/jsx(Component, {
        showElement: showElement,
        ...props
      })
    });
  };
  wrapped.defaultProps = {
    delay: null,
    reset: false,
    root: null,
    rootMargin: '150px',
    threshold: 0.25
  };
  wrapped.propTypes = {
    delay: PropTypes.number,
    reset: PropTypes.bool,
    root: PropTypes.string,
    rootMargin: PropTypes.string,
    threshold: PropTypes.number
  };
  return wrapped;
};
withDetectInViewport.propTypes = {
  Component: PropTypes.element.isRequired
};
var withDetectInViewport$1 = withDetectInViewport;

export { withDetectInViewport$1 as default };
//# sourceMappingURL=index.js.map
